import axios from 'axios';

export default axios.create({
    baseURL: 'https://yoga-andrea.ca/api'
    // baseURL: 'http://localhost:3000'
});